import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import garageReducer from './slices/garageSlice';
import feedReducer from './slices/feedSlice';
import notificationReducer from './slices/notificationSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    garage: garageReducer,
    feed: feedReducer,
    notifications: notificationReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false })
});

export default store;
